import {
  AccordionHeader,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  AccordionTitle,
} from '@apollo/orbit';
import React from 'react';
import { useInView } from 'react-intersection-observer';

import { ErrorInsightsListGroupByColumn } from 'src/lib/graphqlTypes/types';

import { ErrorBreakdownWithData } from './ErrorBreakdown';
import { ErrorGroupTitle } from './ErrorGroupTitle';
import { BreakdownOption, GroupOption } from './GroupByButton';
import { CodeInfoIcon, GroupIcon, ServiceIcon } from './GroupIcon';
import { useDisplayNameTranslator } from './useDisplayNameTranslator';

interface Props {
  groupByDimension: GroupOption;
  groupByDimensionValue: string;
  groupErrorCount: number;
  groupColor: string;
  breakdownByDimension: BreakdownOption;
  isDisabled?: boolean;
}

export function ErrorGroup({
  groupByDimension,
  groupByDimensionValue,
  groupErrorCount,
  breakdownByDimension,
  groupColor,
  isDisabled,
}: Props) {
  const { translateToDisplayName } = useDisplayNameTranslator();

  const [inViewRef, inView] = useInView();

  return (
    <AccordionItem ref={inViewRef} isDisabled={isDisabled}>
      <AccordionHeader>
        <AccordionTitle className="w-full pl-2">
          <ErrorGroupTitle
            title={translateToDisplayName(
              groupByDimensionValue,
              groupByDimension,
            )}
            icon={
              groupByDimension ===
              ErrorInsightsListGroupByColumn.SERVICE_OR_AGENT ? (
                <ServiceIcon serviceName={groupByDimensionValue} />
              ) : groupByDimension === ErrorInsightsListGroupByColumn.CODE ? (
                <GroupIcon
                  groupByDimension={groupByDimension}
                  dimensionValue={groupByDimensionValue}
                />
              ) : undefined
            }
            rightIcon={
              groupByDimension === ErrorInsightsListGroupByColumn.CODE ? (
                <CodeInfoIcon code={groupByDimensionValue} />
              ) : undefined
            }
            groupColor={groupColor}
            errorCount={groupErrorCount}
          />
        </AccordionTitle>
        <AccordionIcon />
      </AccordionHeader>
      <AccordionPanel>
        <ErrorBreakdownWithData
          groupByDimension={groupByDimension}
          groupByDimensionValue={groupByDimensionValue}
          groupColor={groupColor}
          breakdownByDimension={breakdownByDimension}
          inView={inView}
        />
      </AccordionPanel>
    </AccordionItem>
  );
}
